<template>
  <div id="mapid"></div>
</template>

<script>
import constant from "@/constant";

export default {
  props: {
    marker: Array,
    mapVisible: {
      type: Boolean,
      default: false,
    },
    locations: {},
  },
  data() {
    return {
      myMap: void 0,
      markers: [],
      carIcon: require("@/assets/img/car.png").default,
      companyIcon: require("@/assets/img/factory.svg").default,
      orderStatusConstant: constant.orderStatusConstant,
    };
  },
  mounted() {
    this.myMap = L.map("mapid", {
      zoomControl: true,
      zoom: 1,
      zoomAnimation: false,
      fadeAnimation: true,
      markerZoomAnimation: true,
    });
    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        maxZoom: 18,
        id: "mapbox/streets-v11",
        tileSize: 512,
        zoomOffset: -1,
        accessToken:
          "pk.eyJ1IjoibmhhdGh1YW54eCIsImEiOiJja3R3ZzlnNDcyamRiMndwcTVxeXpsMWJyIn0.fds4Rlkcj251RusWeuYLkA",
      }
    ).addTo(this.myMap);
  },
  watch: {
    marker: {
      handler(val) {
        if (val.length != 0) {
          let self = this;
          self.removeLayers();
          if (val.length > 0) {
            self.showVehicle();
            self.showLocations(val);
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    showVehicle() {
      let self = this;
      //   Set view bằng kinh độ điểm nhận và vĩ độ điểm trả
      self.myMap.setView(
        [
          self.marker[0].latitude_destination_id,
          self.marker[0].longitude_arrival_id,
        ],
        10
      );
      let myFeatureGroup = L.featureGroup().addTo(self.myMap);
      let carIcon = L.icon({
        iconSize: [42, 42], // size of the icon
        popupAnchor: [0, 0],
        iconUrl: self.carIcon,
      });
      self.marker
        .filter(
          (p) => p.order_status == self.orderStatusConstant.DANG_VAN_CHUYEN
        )
        .map((item) => {
          if (
            item.latitude !== null ||
            (item.latitude !== "" && item.longitude !== null) ||
            item.longitude !== ""
          ) {
            let marker = L.marker([item.latitude, item.longitude], {
              icon: carIcon,
            })
              .bindPopup(
                window.__t('js.bien_so_vehicle_br_ma_don_order_br_vi_tri_location', {
                  vehicle: item.reg_no,
                  order: item.order_code,
                  location: item.current_location,
                })
              )
              .openPopup()
              .addTo(myFeatureGroup);
            marker.id_location = item.company_id;
            self.markers.push(marker);
          }
        });
    },
    showLocations(location) {
      let self = this;
      //   self.myMap.setView([19.4902954, 105.2518148], 8.5);
      let company = L.featureGroup().addTo(self.myMap);

      let companyIcon = L.icon({
        iconSize: [42, 42], // size of the icon
        popupAnchor: [0, 0],
        iconUrl: self.companyIcon,
      });
      location.map((item) =>{
     if (
        (item.latitude_arrival_id !== null ||
        item.latitude_arrival_id !== "") &&
          (item.longitude_arrival_id !== null ||
        item.longitude_arrival_id !== "")
      ) {
        let markerArrival = L.marker(
          [item.latitude_arrival_id, item.longitude_arrival_id],
          {
            icon: companyIcon,
          }
        )
          .bindPopup(window.__t('js.diem_tra_hang_location', { location: item.name_of_location_arrival_id }))
          .openPopup()
          .addTo(company);
        self.markers.push(markerArrival);
      }
      if (
        (item.latitude_destination_id !== null ||
        item.latitude_destination_id !== "") &&
          (item.longitude_destination_id !== null ||
        item.longitude_destination_id !== "")
      ) {
        let markerDes = L.marker(
          [item.latitude_destination_id, item.longitude_destination_id],
          {
            icon: companyIcon,
          }
        )
          .bindPopup(
            window.__t('js.diem_nhan_hang_location', { location: item.name_of_location_destination_id })
          )
          .openPopup()
          .addTo(company);
        self.markers.push(markerDes);
      }
      })
    },
    removeLayers() {
      let self = this;
      if (self.markers.length != 0) {
        for (let j = 0; j < self.markers.length; j++) {
          self.myMap.removeLayer(self.markers[j]);
        }
      }

      if (self.popup != undefined) {
        self.popup.removeFrom(self.myMap);
      }

      self.markers = [];
    },
  },
};
</script>

<style scoped>
#mapid {
  min-height: 60vh;
}
</style>
